import { render } from "./AddNewBranch.vue?vue&type=template&id=6420d540&scoped=true"
import script from "./AddNewBranch.vue?vue&type=script&lang=js"
export * from "./AddNewBranch.vue?vue&type=script&lang=js"

import "./AddNewBranch.vue?vue&type=style&index=0&id=6420d540&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6420d540"]])

export default __exports__